import { createContext } from 'react';
import RateCardRootStore from '../rate-card-root-store';

export const RateCardStoreContext = createContext<RateCardRootStore>(undefined as unknown as RateCardRootStore);
export const StoreProvider = RateCardStoreContext.Provider;
